import Component, { mixins } from 'vue-class-component'

import WithRender from './OverviewFicheRepondant.html'

import {
  MButton,
  MButtonSkin,
  MMessage,
  MMessageState,
  MSpinner,
  MToast,
  MToastPosition,
  MToastState,
  MToastTimeout,
  MToastDuration
} from '@ulaval/modul-components'

import FicheRepondantService, { IFicheRepondantAfterDeleteEventPayload, IFicheRepondantFetchResponse } from '../FicheRepondant.service'
import { IFicheRepondantModel } from '../FicheRepondant.model'
import FicheRepondantCard from './FicheRepondantCard'
import ROUTES from '@/router/ROUTES'
import EventBus from '@/EventBus'
import { EVENTS as FicheRepondantService_EVENTS } from '../FicheRepondant.service'
import { LOCAL_STORAGE_KEY_TOKEN } from '@/modules/global/user-session/UserSession.store'

@WithRender
@Component({
  components: {
    FicheRepondantCard,
    MButton,
    MMessage,
    MSpinner,
    MToast
  }
})
export default class OverviewFicheRepondant extends mixins(FicheRepondantService) {
  private fichesRepondant: Array<IFicheRepondantModel> = []
  private nombreCasSpeciauxRepondantDisponible: number = 0
  private isLoadingOverlayActive: boolean = false
  private isDeleteSuccessToastOpen: boolean = false

  private readonly MButtonSkin: object = MButtonSkin
  private readonly MMessageState: object = MMessageState
  private readonly MToastPosition: object = MToastPosition
  private readonly MToastState: object = MToastState
  private readonly MToastTimeout: object = MToastTimeout

  private get localStorageToken(): string | null {
    return localStorage.getItem(LOCAL_STORAGE_KEY_TOKEN)
  }

  private mounted(): void {
    this.loadFichesRepondant()
    this.afterFicheRepondantDeleted()
  }

  private afterFicheRepondantDeleted(): void {
    EventBus.$on(FicheRepondantService_EVENTS.AFTER_DELETE, (payload: IFicheRepondantAfterDeleteEventPayload) => {
      this.loadFichesRepondant(false)
      this.isDeleteSuccessToastOpen = true

      setTimeout(() => {
        this.isDeleteSuccessToastOpen = false
      }, MToastDuration.DesktopShort)
    })
  }

  private loadFichesRepondant(displayLoadingOverlay: boolean = true): void {
    this.isLoadingOverlayActive = displayLoadingOverlay || false

    this.service_ficheRepondantService_fetchList(this.$route.query['code-session'] as string)
      .then((response: IFicheRepondantFetchResponse) => {
        this.fichesRepondant = response.casRepondantFiches || []
        this.nombreCasSpeciauxRepondantDisponible = response.nombreCasSpeciauxRepondantDisponible || 0
      }).finally(() => {
        this.isLoadingOverlayActive = false
      })
  }

  private onNavigateToSoumissionButtonClick(): void {
    this.mixin_router_navigate({
      name: ROUTES.FICHE_REPONDANT_CREATE,
      params: this.$route.params,
      query: this.$route.query
    })
  }

  private onNavigateToDossierExamenButtonClick(): void {
    this.mixin_router_navigate({
      name: ROUTES.INSCRIPTION_ETUDIANT,
      params: {
        ...this.$route.params,
        token: this.localStorageToken
      },
      query: this.$route.query
    })
  }
}
